import { render, staticRenderFns } from "./studentTitleCard.vue?vue&type=template&id=0a2579b8&scoped=true&"
import script from "./studentTitleCard.vue?vue&type=script&lang=js&"
export * from "./studentTitleCard.vue?vue&type=script&lang=js&"
import style0 from "./studentTitleCard.vue?vue&type=style&index=0&id=0a2579b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2579b8",
  null
  
)

export default component.exports